import React, { useEffect, useContext } from "react";

//global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

//use browser history
import { useHistory } from "react-router-dom";

// Styling
import "../../Styles/MainPage.scss";

const HelpfulMessage = () => {
  const history = useHistory();
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  // Console logo SVG format
  const logo =
  "https://weaviate.io/img/site/weaviate-nav-logo-light.svg";

  useEffect(() => {
    const module = window.location.pathname.split("/")[2];
    setState({
      ...state,
      currentModule: module,
    });
    history.push(`/console/${state.currentModule}/info-page`);

    window.scrollTo(0, 0);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="__HelpfulMessage">
      <img
        src={logo}
        alt="Logo"
        onClick={() => {
          const { origin, pathname} = window.location;
          let target = origin;
          if (pathname.startsWith('/console/wcs')) {
            target = `${window.location.origin}/console/wcs`;
          }
          
          if (pathname.startsWith('/console/query')) {
            target = `${window.location.origin}/console/query`;
          }
          
          window.location.href = target;
        }}
      />
      <div className="__message">
        <h1>Oops, looks like you're not connected to a Weaviate instance</h1>
        <p>
          {`In order to use the ${
            window.location.pathname.split("/")[2]
          } module, you first need to connect to a
          Weaviate instance. You can also log in using our Weaviate Cloud
          Service`}
          . <br />
          Click{" "}
          <a href={`${window.origin}`} id="loginPage">
            here
          </a>{" "}
          to login via WCS or to connect to a self-hosted Weaviate. <br />
          Click{" "}
          <a
            href="https://www.semi.technology/products/weaviate-cloud-service/index.html"
            id="learnMoreWCS"
          >
            here
          </a>{" "}
          to learn more about our Weaviate Cloud Service.
        </p>
      </div>
    </div>
  );
};

export default HelpfulMessage;
